<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLocation_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8 15s5.6-4.375 5.6-8.75C13.6 3.35 11.093 1 8 1 4.907 1 2.4 3.35 2.4 6.25 2.4 10.625 8 15 8 15Zm0-7a2.1 2.1 0 1 0 0-4.2A2.1 2.1 0 0 0 8 8Z"
        clip-rule="evenodd"
    />
</svg>
